import { BooleanInput } from 'react-admin'
import { SfmList } from 'src/AppScopes/resource'
import type { SfmListProps } from 'src/AppScopes/resource'
import { CustomDatagrid } from 'src/components/CustomDatagrid'
import { SfmTextField } from 'src/components/SfmFields'
import { RoleEnum } from 'src/UserIdentity'

export function List(props: SfmListProps) {
  return (
    <SfmList
      {...props}
      acceptedEditRoles={[RoleEnum.ROLE_CONFIGURATOR]}
      filters={[
        <BooleanInput
          key="archives"
          label="filters.archived.items"
          source="showArchived"
        />,
      ]}
    >
      <CustomDatagrid>
        <SfmTextField source="name" label="resource.items.name" />
        <SfmTextField source="reference" label="resource.items.reference" />
        <SfmTextField source="description" label="resource.items.description" />
      </CustomDatagrid>
    </SfmList>
  )
}
